import { render } from "./CTextEditor.vue?vue&type=template&id=13f7416d"
import script from "./CTextEditor.vue?vue&type=script&lang=js"
export * from "./CTextEditor.vue?vue&type=script&lang=js"
script.render = render

export default script